module.exports = __webpack_public_path__ + "static/media/content.2a6299e6.png";